// Export parseStartTime for use in other components
export function parseStartTime(startTime) {
    if (!startTime) {
        return null;
    }
    try {
        // Handle ISO string format (e.g., "2000-01-01T10:30:00.000" or "2000-01-01T10:30:00.000Z")
        if (startTime.includes('T')) {
            const timeMatch = startTime.match(/T(\d{2}):(\d{2})(?::(\d{2}))?(?:\.(\d+))?(?:Z)?/);
            if (timeMatch) {
                const hours = parseInt(timeMatch[1], 10);
                const minutes = parseInt(timeMatch[2], 10);
                return { hours, minutes };
            }
        }
        // Fallback: try parsing as Date
        const date = new Date(startTime);
        if (!isNaN(date.getTime())) {
            return { hours: date.getHours(), minutes: date.getMinutes() };
        }
    }
    catch (error) {
        // Silently handle parsing errors
    }
    return null;
}
export function getDayTypeDotColors(dayItems, selected, theme) {
    const types = ['event'];
    return types
        .filter((type) => dayItems.some((item) => item.type === type))
        .map((type) => {
        if (type === 'event')
            return theme.palette.success.main;
        return theme.palette.primary.main;
    });
}
export const MAX_VISIBLE_ITEMS = 2;
export function getMonthMatrix(year, month) {
    const firstDay = new Date(year, month, 1);
    const lastDay = new Date(year, month + 1, 0);
    const matrix = [];
    // Make Monday = 0, Sunday = 6
    const weekStartDay = (firstDay.getDay() + 6) % 7;
    let day = 1 - weekStartDay;
    while (day <= lastDay.getDate()) {
        const week = [];
        for (let i = 0; i < 7; i++) {
            const date = new Date(year, month, day);
            if (day > 0 && day <= lastDay.getDate()) {
                week.push(date);
            }
            else {
                week.push(null);
            }
            day++;
        }
        matrix.push(week);
    }
    return matrix;
}
export const WEEK_DAYS = [
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
    'Sunday'
];
export const HOURS = Array.from({ length: 24 }, (_, i) => 0 + i); // 0:00 to 23:00
export function getItemStyle(item) {
    const variant = item.status === 'pending' ? 'soft' : 'soft';
    if (item.type === 'event') {
        return {
            color: 'error',
            variant
        };
    }
    return {
        color: 'default',
        variant: 'filled'
    };
}
export function getSlotItemsForHour(items, currentDate, hour) {
    return items.filter((item) => {
        const isEvent = item.type === 'event';
        const itemStartDate = new Date(item.start.getFullYear(), item.start.getMonth(), item.start.getDate());
        const itemEndDate = new Date(item.end.getFullYear(), item.end.getMonth(), item.end.getDate());
        const isInRange = currentDate >= itemStartDate && currentDate <= itemEndDate;
        // Event: show in slot based on startTime if available, otherwise fallback to 0:00 (midnight)
        if (isEvent && itemStartDate.getTime() === itemEndDate.getTime()) {
            const timeInfo = parseStartTime(item.startTime);
            if (timeInfo) {
                // Use startTime to determine which hour slot
                return currentDate.toDateString() === item.start.toDateString() && hour === timeInfo.hours;
            }
            else {
                // Fallback: show at 0:00 (midnight) if no startTime
                return currentDate.toDateString() === item.start.toDateString() && hour === 0;
            }
        }
        return false;
    });
}
